<template>
  <div class="el-card pd20">
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box list-box2">
        <el-table height="300" :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="100" label="序号"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="price" label="原价"></el-table-column>
          <el-table-column prop="discount_price" label="优惠价格"></el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="deleteProduct(scope.$index, scope.row)"
              >移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加按钮 -->
      <el-button
        type="primary"
        class="addBtn"
        size="mini"
        icon="el-icon-circle-plus"
        @click="addProduct()"
        circle
      ></el-button>
    </div>
    <!-- 添加套餐商品 -->
    <el-dialog title="添加套餐商品" :visible.sync="addProductShow">
      <div class="dialog-box">
        <el-table border show-overflow-tooltip style="width: 100%" :data="productList">
          <el-table-column prop="name" label="分类名称"></el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">{{scope.row.type == 1?'大分类':'小分类'}}</template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.product"
                type="info"
                size="small"
                icon="el-icon-check"
                circle
              ></el-button>
              <el-button
                v-else
                type="primary"
                size="small"
                @click="checkProduct(scope.$index, scope.row)"
                icon="el-icon-check"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { productAll } from "@/api/measurement";
export default {
  data() {
    return {
      pages: {},
      list: [],
      addProductShow: false,
      productList: [],
      related_ids:''
    }
  },
  props: ['relatedIds'],
  methods: {
    /*
     *@param: index 下标、row 点击行的对象
     *@return:
     *@Description: 删除列表商品
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-10 17:34:52
     */
    deleteProduct(index, row) {
      let arr = this.related_ids.split(',');
      this.$delete(arr,index);
      this.related_ids = arr.join(',');
      this.$emit('relatedHandle',this.related_ids);
      this.$delete(this.list, index);
      this.$delete(this.productList[row.index], "product");
    },
    /*
     *@param: index 下标、row 点击行的对象
     *@return:
     *@Description:
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-10 17:00:31
     */
    checkProduct(index, row) {
      this.productList[index]["product"] = row.id;
      row["index"] = index;
      this.list.push(row);
      this.related_ids = (this.related_ids && this.related_ids!='')?(this.related_ids+','+row.id):row.id;
      this.$emit('relatedHandle',this.related_ids);
      this.addProductShow = false;
    },
    /*
     *@param:
     *@return:
     *@Description: 添加套餐商品
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-10 16:49:34
     */
    addProduct() {
      this.addProductShow = true;
    },
    pullData() {
      productAll({
        type:1
      }).then(data => {
        this.productList = data.list;
        this.productList.forEach((item, index) => {
          if(this.relatedIds && this.relatedIds.split(",").includes(String(item.id))){
            item["product"] = item.id;
            item["index"] = index;
            this.list.push(item);
          }
        });
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}
.list-box2 {
  max-height: 300px;
  overflow: auto;
}
.dialog-box{
    padding: 10px;
    background-color: #ffffff;
}
</style>